module Meevo.Plugins.DocsAndForms {
    export class HtmlBeautyDirector {

        beautiFormBuilder(htmlBeautyBuilder: IHtmlBeautyBuilder): void {
            htmlBeautyBuilder.fixEscapedStrings();
            htmlBeautyBuilder.replaceReservedWords();
            htmlBeautyBuilder.clearAngularStuff();
            htmlBeautyBuilder.removeReservedComments();
            htmlBeautyBuilder.fixDataAttribute();
            htmlBeautyBuilder.removeEmptyLines();
            htmlBeautyBuilder.newTagFromNewLine();
            htmlBeautyBuilder.addSpacesInsideBlocks();
            htmlBeautyBuilder.placeNewLinesForStartAndEnd();
            htmlBeautyBuilder.moveCommentsToTheStart();
            htmlBeautyBuilder.attributesToTheNewLines();
            htmlBeautyBuilder.addNewLinesBetweenBlocks();
            htmlBeautyBuilder.beautifyBR();
        }

    }
}
